import { render, staticRenderFns } from "./stockreport.vue?vue&type=template&id=494272ae&"
import script from "./stockreport.vue?vue&type=script&lang=js&"
export * from "./stockreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports